// removed by extract-text-webpack-plugin
module.exports = {"outer":"src-components-Video-___index__outer___CMkun","vimeoContainer":"src-components-Video-___index__vimeoContainer___2xlDQ","vimeoMedia":"src-components-Video-___index__vimeoMedia___N2zL8","playLarge":"src-components-Video-___index__playLarge___39w2X","playMed":"src-components-Video-___index__playMed___3fD1W","playSmall":"src-components-Video-___index__playSmall___MqjnK","media":"src-components-Video-___index__media___3QT96"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/index.css
// module id = 1063
// module chunks = 3